export default {"src":"https://dap-cjx0935f8-dap-rewrite.vercel.app/_next/static/media/icon-marker.67e1b489.svg","height":28,"width":22};